<template>
    <div class="p-2 row-gap row-gap-10-px">
        <div class="line">
            <div class="field-item">
                <div class="lable_item">グループ</div>
                <div class="item-group input-no-required">
                    <ans-select
                        id="group-filter"
                        v-model="data.group.GroupID"
                        :options="options.group"
                        input-class="custom-border"
                        remove-empty-option
                        :on-change="$emit('set-list-span-member')"
                    />
                </div>
            </div>
        </div>
        <div v-if="listSpanMember && listSpanMember.length > 0" class="line">
            <div class="field-item">
                <div class="group-member-label-space"></div>
                <div class="item-group">
                    <div id="group-members-content" class="group-members">
                        <span v-for="(name, index) in listSpanMember" :key="index" class="group-members-tag">{{ name }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="line">
            <div class="field-item">
                <div class="lable_item">件名</div>
                <div class="item-group input-no-required">
                    <ans-input id="Subject" input-class="custom-border" :maxLength="100" v-model="data.group.Subject" is-enable-i-m-e is-required />
                </div>
            </div>
        </div>
        <div class="line">
            <div class="field-item">
                <div class="lable_item h-100">メッセージ</div>
                <div class="item-group">
                    <ans-input
                        id="Body"
                        type="textarea"
                        :rows="4"
                        input-class="custom-border"
                        :maxLength="100"
                        v-model="data.group.Body"
                        is-enable-i-m-e
                        is-required
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    name: 'ComposeGroup',
    props: { listSpanMember: Array },
    computed: { ...mapState('app', ['user', 'isShowLeftMenu', 'dmMessageMode']), ...mapState('MNG_DM_Message_Store', ['data', 'options']) }
};
</script>
<style scoped>
.group-member-label-space {
    width: 26%;
}
</style>
